
import React, { useState } from 'react';
import { addEmail } from '../api/parentCoach';

export default function Privacy() {

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="bg-gradient-to-br from-slate-700 to-slate-900 text-white py-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
            Politique des confidentialité
          </h1>
        </div>
      </header>
      <section className="py-16 px-6 flex-grow">
        <div className="max-w-6xl mx-auto">
          
          <div className="flex flex-col md:flex-row items-center gap-12">
            <div className="flex-1">

              <div className="flex items-center gap-4 mb-8">
                <h2 className="text-3xl font-bold text-slate-700">Politique de confidentialité - Oria Coach</h2>
              </div>
              <p className="text-lg text-gray-600 mb-5">
                Oria Coach collecte et traite les données nécessaires au fonctionnement de son service d’orientation (nom, prénom, numéro WhatsApp, messages).
                <br />Ces données sont utilisées uniquement pour fournir les fonctionnalités de conseil et d’échange via WhatsApp et sont supprimées sur demande.
              </p>
              <p className="text-lg text-gray-600 mb-5">
                Pour toute question ou suppression, contactez : matthieu.brau@gmail.com
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="bg-slate-800 text-white py-12 px-6 text-center mt-auto">
        <p className="font-semibold text-lg mb-2">ParentCoach | Oria Coach</p>
        <p className="text-sm opacity-80 mb-2">Accompagnez sereinement l'orientation de votre adolescent</p>
        <p className="text-xs opacity-70">Dernière mise à jour : octobre 2025</p>
      </footer>
    </div>
  );
}